import React, { Fragment } from "react";
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Badge,
  Preloader,
  TextEditor,
  Popover,
  Toggle,
  Input,
} from "framework7-react";

import moment from "moment";
import * as geofire from "geofire-common";

import { WalletSvg } from "../components/crumbs";

import cities from "../static/ng.json";
import BranchMap from "../components/BusinessMap";
import useGeoCode from "../utils/geoCode";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect, withStorage } from "../HOCs";
import { DocArray, Doc } from "../utils/_classes";
import { LOAD_BRANCHES } from "../store/actions/firestore";
import {
  generateId,
  deleteFile,
  uploadFile,
  isEmpty,
  toast,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  payStackTransferCharge,
  initiateATransfer,
  handleErrors,
  sendOneTimePassword,
  verifyOneTimePassword,
  addOrRemoveBank,
  isValidEmail,
  makeRequest,
  totalEasychawDeposit,
} from "../utils/_helpers";
import { ThemeConsumer } from "styled-components";

// image viewer from https://www.npmjs.com/package/react-medium-image-zoom
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

class DeliveryAgents extends React.Component {
  constructor(props) {
    super(props);

    this.popupRef = React.createRef();
    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
        order: "",
      },

      // agentform
      addAgentButton: "Upload Agent Details",
      agentImage1: "static/icon-512x512@1x.png",
      agentImage2: "static/icon-512x512@1x.png",
      agent: {
        deliveryAgentId: this.props.auth.uid,
        images: {
          agentImage: null,
          driverLicense: null,
        },
        name: "",
        address: "",
        phone: "",
        status: "Free",
        branch: "",
      },

      // branchform
      MDEmail: "",
      addBranchButton: "Upload Branch Details",
      branchEdit: false,
      branchUnsub: null,
      branch: {
        deliveryAgentId: this.props.auth.uid,
        name: "",
        address: "",
        state: "",
        city: "",
        phone: "",
        geoLoc: null,
      },
      branchMD: false,

      // Bank
      addBankButton: "Upload Bank Details",
      bank: {
        bankName: "",
        accountName: "",
        accountNumber: "",
        sortCode: "",
        bankCode: "",
      },
      banks: [],
      BanksWithIssues: ["Parallex Bank"],

      // Withdrawals
      withdrawalButton: "Confirm Transaction",
      withdrawalInfo: {
        recipientCode: "",
        amount: 0,
      },

      // order buttons
      acceptOrderButton: "Accept Order",
      declineOrderButton: "Decline Order",
      completeOrderButton: "Complete Order",
      reportIssueButton: "Submit Report",

      deliveryPersonId: "",
      confirmationCode: "",
      orderIssue: "",

      operatingTime: [
        "12 am",
        "1 am",
        "2 am",
        "3 am",
        "4 am",
        "5 am",
        "6 am",
        "7 am",
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12 pm",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
        "7 pm",
        "8 pm",
        "9 pm",
        "10 pm",
        "11 pm",
      ],

      operatingDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    };
  }

  render() {
    //[case-1] user is not yet a delivery agent
    if (!this.props.delivery[this.props.auth.uid]) {
      return (
        <Page id="delivery-page-unregistered">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Delivery Agent Dashboard</NavTitle>
          </Navbar>
          <Block
            style={{
              backgroundColor: "#b3e5ff",
              borderLeft: "3px solid #03a9f4",
              color: "#03a9f4",
              marginTop: 0,
              paddingTop: "16px",
              paddingBottom: "16px",
            }}
          >
            <small>Become a Delivery Agent &nbsp;&nbsp;&nbsp;</small>
            <Link
              style={{
                width: "45%",
                color: "white",
                backgroundColor: "#03a9f4",
                display: "inline",
                padding: "10px",
              }}
              href="/business-registration/2/"
            >
              Delivery Agent Sign Up
            </Link>
          </Block>
        </Page>
      );
    }

    //[case-2] user is a registered delivery agent awaiting admin approval
    if (this.props.delivery[this.props.auth.uid].accountStatus === "Pending") {
      return (
        <Page id="delivery-page-pending">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Delivery Agent Dashboard</NavTitle>
          </Navbar>
          <Block
            style={{
              backgroundColor: "#ffe0b2",
              borderLeft: "3px solid #ff9800",
              color: "#ef6c00",
              marginTop: 0,
              paddingTop: "16px",
              paddingBottom: "16px",
            }}
          >
            <Row>
              <Col>
                <p>Application Pending &nbsp;&nbsp;&nbsp;</p>
              </Col>
              <Col>
                <Link
                  style={{
                    color: "white",
                    backgroundColor: "#ff9800",
                    padding: "10px",
                    float: "right",
                  }}
                  tabLink="#view-message-master"
                  onClick={() => this.navMessage("account", "admin", "account")}
                >
                  Contact Admin
                </Link>
              </Col>
            </Row>
            <Row
              style={{
                backgroundColor: "antiquewhite",
                marginTop: "10px",
                padding: "8px",
              }}
            >
              <Col>
                <p style={{ margin: "0", color: " #9E9E9E" }}>
                  Please contact Admin after 24 hours if account is still
                  pending.
                </p>
              </Col>
            </Row>
          </Block>
        </Page>
      );
    }

    //[case-3] user is a registered delivery agent suspended by admin
    if (
      this.props.delivery[this.props.auth.uid].accountStatus === "Suspended"
    ) {
      return (
        <Page id="delivery-page-suspended">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Delivery Agent Dashboard</NavTitle>
          </Navbar>
          <Block
            style={{
              backgroundColor: "pink",
              borderLeft: "3px solid red",
              color: "red",
              marginTop: 0,
              paddingTop: "16px",
              paddingBottom: "16px",
              fontSize: "10px",
            }}
          >
            <Row>
              <Col>
                <p>Account Suspended &nbsp;&nbsp;&nbsp;</p>
              </Col>
              <Col>
                <Link
                  style={{
                    color: "white",
                    backgroundColor: "#ff8d8d",
                    padding: "10px",
                    float: "right",
                  }}
                  tabLink="#view-message-master"
                  onClick={() => this.navMessage("account", "admin", "account")}
                >
                  Contact Admin
                </Link>
              </Col>
            </Row>
          </Block>
        </Page>
      );
    }

    //[case-4] user is a registered delivery agent approved by admin
    return (
      <Page
        id="delivery-page"
        onPageBeforeRemove={() => {
          if (this.state.branchUnsub) {
            this.state.branchUnsub();
          }
        }}
      >
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding> Delivery Agent Dashboard</NavTitle>
          <NavRight>
            <Button
              iconF7="gear_alt"
              onClick={() => {
                this.setState({
                  popupOpened: true,
                  popupDataChanged: true,
                  popupData: {
                    title: "Services Settings",
                    which: "services-settings",
                  },
                });
              }}
            ></Button>
          </NavRight>
        </Navbar>

        <Tabs animated style={{ overflowY: "scroll" }}>
          {/* Agents Tab */}
          <Tab id="delivery-agents" tabActive>
            <Card className="data-table data-table-init">
              <CardHeader>
                <div className="data-table-title">All Delivery Agents</div>
                <div className="data-table-actions">
                  <Button
                    outline
                    iconF7="plus_circle"
                    onClick={() => {
                      // check if delivery agent has a wallet
                      if (!this.props.delivery[this.props.auth.uid].walletId) {
                        this.setState({
                          ...this.state,
                          addAgentButton: "Upload Agent Details",
                        });
                        return toast(this.$f7.toast, {
                          text: "Please update your bank details in wallet.",
                          position: "bottom",
                          horizontalPosition: "center",
                          closeButton: true,
                          cssClass: "custom-toast",
                          closeTimeout: 4000,
                        });
                      } else {
                        this.setState({
                          popupOpened: true,
                          popupDataChanged: true,
                          popupData: {
                            title: "Add Agent Details",
                            which: "add-agent",
                          },
                        });
                      }
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;Add Agent
                  </Button>
                </div>
              </CardHeader>
              <CardContent padding={false}>
                {this.props.loadingDoc && this.props.agents.length === 0 ? (
                  <Block className="text-align-center">
                    <Preloader></Preloader>
                  </Block>
                ) : !this.props.loadingDoc && this.props.agents.length === 0 ? (
                  <Block
                    style={{
                      backgroundColor: "#b3e5ff",
                      borderLeft: "3px solid #03a9f4",
                      color: "#03a9f4",
                      marginTop: 0,
                      paddingTop: "16px",
                      paddingBottom: "16px",
                    }}
                  >
                    <small>You don't have an agent &nbsp;&nbsp;&nbsp;</small>
                  </Block>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className="label-cell">Action</th>
                        <th className="label-cell">Agent image</th>
                        <th className="label-cell">Agent id</th>
                        <th className="label-cell">Agent name</th>
                        <th className="label-cell">Agent address</th>
                        <th className="numeric-cell">Agent phone</th>
                        <th className="label-cell">Branch</th>
                        <th className="label-cell">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.agents.map(
                        ({
                          id,
                          name,
                          images: { agentImage, driverLicense },
                          address,
                          phone,
                          branch,
                          status,
                        }) => (
                          <tr key={id}>
                            <td className="label-cell">
                              <Button
                                fill
                                style={{
                                  backgroundImage:
                                    "linear-gradient(#FF6969, #E02020)",
                                  color: "white",
                                  maxWidth: "41px",
                                }}
                                iconF7="trash_circle"
                                onClick={(e) =>
                                  this.deleteAgent(
                                    agentImage,
                                    driverLicense,
                                    id,
                                  )
                                }
                              ></Button>
                            </td>
                            <td className="label-cell">
                              <Zoom>
                                <img
                                  src={agentImage.URL}
                                  width={100}
                                  style={{ border: "1px solid #fed448" }}
                                  className="elevation-1"
                                />
                              </Zoom>
                            </td>
                            <td className="label-cell">{id}</td>
                            <td className="label-cell">
                              <div>{name}</div>
                            </td>
                            <td className="label-cell">
                              <div>{address}</div>
                            </td>
                            <td className="numeric-cell">{phone}</td>
                            <td className="label-cell">
                              <div>{branch ? branch.name : "HQ"}</div>
                            </td>
                            <td className="label-cell">{status}</td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                )}
              </CardContent>
            </Card>
          </Tab>

          {/* Wallet Tab */}
          <Tab id="delivery-wallet">
            <Block>
              <Row>
                <Col width="100" className="xsmall-40">
                  <div
                    style={{
                      width: "103%",
                      paddingTop: "9px",
                      marginLeft: "-6px",
                      position: "relative",
                    }}
                  >
                    <WalletSvg
                      id="deliveryagentcard"
                      title="Delivery Agent Wallet"
                    />
                    {this.props.wallets &&
                    this.props.wallets[
                      this.props.delivery[this.props.auth.uid].walletId
                    ] ? (
                      <span className="walletBalance">
                        {new Intl.NumberFormat("en-GB", {
                          style: "currency",
                          currency: "NGN",
                        }).format(
                          Number(
                            this.props.wallets[
                              this.props.delivery[this.props.auth.uid].walletId
                            ].walletBalance,
                          ),
                        )}
                      </span>
                    ) : (
                      <span className="walletBalance">NGN 0.00</span>
                    )}
                    <em className="walletBalanceSubText">Wallet Balance</em>
                  </div>
                </Col>
                <Col width="100" className="xsmall-60">
                  <Card
                    className="data-table data-table-init"
                    style={{
                      width: "100%",
                      marginLeft: "0px",
                    }}
                  >
                    <CardHeader>
                      <div className="data-table-title">Bank Details</div>
                      <div className="data-table-actions">
                        <Button
                          outline
                          iconF7="plus_circle"
                          onClick={() => {
                            this.$f7.preloader.show();
                            fetchBanks((error, banks) => {
                              if (error) {
                                toast(this.$f7.toast, {
                                  text: "Something went wrong. Try again",
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                                return this.$f7.preloader.hide();
                              }
                              this.setState({
                                ...this.state,
                                banks,
                                popupOpened: true,
                                popupDataChanged: true,
                                popupData: {
                                  title: "Add Bank Details",
                                  which: "add-bank",
                                },
                              });
                              this.$f7.preloader.hide();
                            });
                          }}
                        >
                          &nbsp;&nbsp;&nbsp;Add Bank
                        </Button>
                      </div>
                    </CardHeader>
                    <CardContent padding={false}>
                      {this.props.loadingDoc && !this.props.wallets ? (
                        <Block className="text-align-center">
                          <Preloader></Preloader>
                        </Block>
                      ) : !this.props.loadingDoc &&
                        (!this.props.wallets ||
                          !this.props.wallets[
                            this.props.delivery[this.props.auth.uid].walletId
                          ]) ? (
                        <Block
                          style={{
                            backgroundColor: "#ffe0b2",
                            borderLeft: "3px solid #ff9800",
                            color: "#ef6c00",
                            marginTop: 0,
                            paddingTop: "16px",
                            paddingBottom: "16px",
                          }}
                        >
                          <small>
                            You don't have a wallet! Please add bank details.
                          </small>
                        </Block>
                      ) : (
                        <table>
                          <thead>
                            <tr>
                              <th>
                                <span className="table-head-label">SNo.</span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Account Name
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Account Number
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Bank Name
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">Action</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.wallets[
                              this.props.delivery[this.props.auth.uid].walletId
                            ] &&
                            this.props.wallets[
                              this.props.delivery[this.props.auth.uid].walletId
                            ].bankDetails.length > 0 ? (
                              this.props.wallets[
                                this.props.delivery[this.props.auth.uid]
                                  .walletId
                              ].bankDetails.map(
                                (
                                  {
                                    bankName,
                                    accountName,
                                    accountNumber,
                                    recipientCode,
                                  },
                                  i,
                                ) => (
                                  <tr key={i}>
                                    <td> {i + 1} </td>
                                    <td>
                                      <div>{accountName}</div>
                                    </td>
                                    <td>{accountNumber}</td>
                                    <td>
                                      <div>{bankName}</div>
                                    </td>
                                    <td>
                                      <Button
                                        fill
                                        style={{
                                          backgroundImage:
                                            "linear-gradient(#FF6969, #E02020)",
                                          color: "white",
                                          maxWidth: "41px",
                                        }}
                                        iconF7="trash_circle"
                                        onClick={() =>
                                          this.deleteBank(i, recipientCode)
                                        }
                                      ></Button>
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ padding: 0 }}>
                                  <Block
                                    style={{
                                      backgroundColor: "#b3e5ff",
                                      borderLeft: "3px solid #03a9f4",
                                      color: "#03a9f4",
                                      marginTop: 0,
                                      paddingTop: "16px",
                                      paddingBottom: "16px",
                                      width: "100%",
                                    }}
                                  >
                                    <small>No bank account registered</small>
                                  </Block>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </CardContent>
                  </Card>

                  {this.props.wallets &&
                  this.props.wallets[
                    this.props.delivery[this.props.auth.uid].walletId
                  ] ? (
                    this.props.wallets[
                      this.props.delivery[this.props.auth.uid].walletId
                    ].ban ? (
                      <Card style={{ margin: "10pt auto" }} inner accordionList>
                        <AccordionItem>
                          <CardHeader>
                            Your acccount has been banned from making a
                            withdrawal
                            <AccordionToggle>
                              <Button
                                outline
                                iconF7="arrowtriangle_down_fill"
                              ></Button>
                            </AccordionToggle>
                          </CardHeader>

                          <AccordionContent>
                            <CardContent>Contact admin</CardContent>
                          </AccordionContent>
                        </AccordionItem>
                      </Card>
                    ) : (
                      <Card style={{ margin: "20pt auto" }} inner accordionList>
                        <AccordionItem>
                          <CardHeader>
                            Make a withdrawal
                            <AccordionToggle>
                              <Button
                                outline
                                iconF7="arrowtriangle_down_fill"
                              ></Button>
                            </AccordionToggle>
                          </CardHeader>

                          <AccordionContent>
                            <CardContent>
                              <List noHairlinesMd>
                                {this.props.wallets[
                                  this.props.delivery[this.props.auth.uid]
                                    .walletId
                                ].pendingWithdrawal &&
                                this.props.wallets[
                                  this.props.delivery[this.props.auth.uid]
                                    .walletId
                                ].pendingWithdrawal.length > 0
                                  ? this.props.wallets[
                                      this.props.delivery[this.props.auth.uid]
                                        .walletId
                                    ].pendingWithdrawal.map((pw, i) => (
                                      <ListItem
                                        key={i}
                                        header="Pending Withdrawal"
                                        title={`#${pw.amount / 100}`}
                                        footer={
                                          pw.status ? "Processing" : "Failed"
                                        }
                                      >
                                        <Button
                                          round
                                          fill
                                          slot="after-title"
                                          disabled={pw.status}
                                          onClick={() =>
                                            this.withdrawalRetry(pw)
                                          }
                                          className="button button-fill-blue"
                                          style={{
                                            minWidth: "20%",
                                          }}
                                        >
                                          Retry
                                        </Button>
                                      </ListItem>
                                    ))
                                  : null}
                                <ListItem title="Transfer charge">
                                  <small slot="after">
                                    {`NGN${payStackTransferCharge(
                                      this.state.withdrawalInfo.amount,
                                    )}`}
                                  </small>
                                  <Icon f7="creditcard" slot="media" />
                                </ListItem>
                                <ListInput
                                  label="Bank account"
                                  type="select"
                                  name="account"
                                  onChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      withdrawalInfo: {
                                        ...this.state.withdrawalInfo,
                                        recipientCode: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Select account"
                                  style={{ paddingLeft: 0 }}
                                >
                                  <Icon f7="briefcase" slot="media" />
                                  <option></option>
                                  {this.props.wallets &&
                                    this.props.wallets[
                                      this.props.delivery[this.props.auth.uid]
                                        .walletId
                                    ] &&
                                    this.props.wallets[
                                      this.props.delivery[this.props.auth.uid]
                                        .walletId
                                    ].bankDetails.map(
                                      (
                                        {
                                          accountName,
                                          bankName,
                                          recipientCode,
                                        },
                                        i,
                                      ) => (
                                        <Fragment key={i}>
                                          <option value={recipientCode}>
                                            {accountName} - {bankName}
                                          </option>
                                        </Fragment>
                                      ),
                                    )}
                                </ListInput>

                                <ListInput
                                  label="Amount to withdraw"
                                  type="number"
                                  placeholder="Mininmum withdrawal is NGN1,000"
                                  info="Mininmum withdrawal is NGN1,000"
                                  required
                                  validate
                                  clearButton
                                  value={this.state.withdrawalInfo.amount}
                                  onChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      withdrawalInfo: {
                                        ...this.state.withdrawalInfo,
                                        amount: e.target.value,
                                      },
                                    })
                                  }
                                  style={{ paddingLeft: 0 }}
                                >
                                  <Icon f7="creditcard_fill" slot="media" />
                                </ListInput>
                              </List>
                            </CardContent>
                            <CardFooter>
                              <Button
                                round
                                fill
                                disabled={
                                  this.state.withdrawalButton !==
                                  "Confirm Transaction"
                                }
                                onClick={this.initiateTransfer.bind(this)}
                                className="button button-fill-blue"
                                style={{
                                  width: "100%",
                                  margin: "5pt auto",
                                }}
                              >
                                {this.state.withdrawalButton ===
                                "Confirm Transaction" ? (
                                  this.state.withdrawalButton
                                ) : (
                                  <Preloader></Preloader>
                                )}
                              </Button>
                            </CardFooter>
                          </AccordionContent>
                        </AccordionItem>
                      </Card>
                    )
                  ) : null}
                </Col>

                <Col width="100">
                  <Card style={{ margin: "10pt auto 0" }}>
                    <CardHeader>Wallet History</CardHeader>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListItem title="Total transactions">
                          <small slot="after">
                            {this.props.transactions.length || "0"}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total amount Received">
                          <small slot="after">
                            {this.props.transactions.length > 0
                              ? new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.transactions
                                    .filter(
                                      (t) =>
                                        t.type === "Received" &&
                                        t.status === "Success",
                                    )
                                    .map((t) => t.amount)
                                    .reduce((a, b) => +a + +b, 0),
                                )
                              : new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(0)}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total amount withdrawn">
                          <small slot="after">
                            {this.props.transactions.length > 0
                              ? new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.transactions
                                    .filter((t) => t.type === "Withdrawn")
                                    .map((t) => t.amount)
                                    .reduce(
                                      (a, b) =>
                                        Number(a.amount) + Number(b.amount),
                                      0,
                                    ),
                                )
                              : new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(0)}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        {this.props.wallets &&
                          this.props.wallets[
                            this.props.delivery[this.props.auth.uid].walletId
                          ] && (
                            <ListItem title="Wallet balance">
                              <small slot="after">
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  Number(
                                    this.props.wallets[
                                      this.props.delivery[this.props.auth.uid]
                                        .walletId
                                    ].walletBalance,
                                  ),
                                )}
                              </small>
                              <Icon f7="number_square" slot="media" />
                            </ListItem>
                          )}
                      </List>
                    </CardContent>
                  </Card>

                  {/* Transaction Summary */}
                  {this.props.transactions?.length ? (
                    <Card
                      className="data-table data-table-init"
                      style={{ width: "100%", marginLeft: "0px" }}
                    >
                      <CardHeader>
                        <div className="data-table-title">
                          Transactions Summary
                        </div>
                      </CardHeader>
                      <CardContent padding={false}>
                        <table>
                          <thead>
                            <tr>
                              <th>
                                <span className="table-head-label">SNo.</span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Branch Name
                                </span>
                              </th>
                              <th>Total Order</th>
                              <th>
                                <span className="table-head-label">
                                  Total Order Completed
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Total Order Declined
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Transaction Amount Completed
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Transaction Amount Declined
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>HQ</td>
                              <td>
                                {
                                  this.props.transactions.filter(
                                    (t) => !t.branch,
                                  ).length
                                }
                              </td>
                              <td>
                                {
                                  this.props.transactions.filter(
                                    (t) =>
                                      !t.branch &&
                                      t.type === "Received" &&
                                      t.status === "Success",
                                  ).length
                                }
                              </td>
                              <td>
                                {
                                  this.props.transactions.filter(
                                    (t) =>
                                      !t.branch &&
                                      t.type === "Received" &&
                                      t.status === "Failed",
                                  ).length
                                }
                              </td>
                              <td>
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.transactions
                                    .filter(
                                      (t) =>
                                        !t.branch &&
                                        t.type === "Received" &&
                                        t.status === "Success",
                                    )
                                    .map((t) => t.amount)
                                    .reduce((a, b) => +a + +b, 0),
                                )}
                              </td>
                              <td>
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.transactions
                                    .filter(
                                      (t) =>
                                        !t.branch &&
                                        t.type === "Received" &&
                                        t.status === "Failed",
                                    )
                                    .map((t) => t.amount)
                                    .reduce((a, b) => +a + +b, 0),
                                )}
                              </td>
                            </tr>
                            {[
                              ...new Set(
                                this.props.transactions
                                  .filter((t) => {
                                    if (t.branch) {
                                      return true;
                                    }
                                    return false;
                                  })
                                  .map((t) => t.branch.name),
                              ),
                            ].map((branchName, i) => (
                              <tr key={i}>
                                <td>{i + 2}</td>
                                <td>{branchName}</td>
                                <td>
                                  {
                                    this.props.transactions.filter(
                                      (t) => t?.branch?.name === branchName,
                                    ).length
                                  }
                                </td>
                                <td>
                                  {
                                    this.props.transactions
                                      .filter(
                                        (t) => t?.branch?.name === branchName,
                                      )
                                      .filter(
                                        (t) =>
                                          t.type === "Received" &&
                                          t.status === "Success",
                                      ).length
                                  }
                                </td>
                                <td>
                                  {
                                    this.props.transactions
                                      .filter(
                                        (t) => t?.branch?.name === branchName,
                                      )
                                      .filter(
                                        (t) =>
                                          t.type === "Received" &&
                                          t.status === "Failed",
                                      ).length
                                  }
                                </td>
                                <td>
                                  {new Intl.NumberFormat("en-GB", {
                                    style: "currency",
                                    currency: "NGN",
                                  }).format(
                                    this.props.transactions
                                      .filter(
                                        (t) => t?.branch?.name === branchName,
                                      )
                                      .filter(
                                        (t) =>
                                          t.type === "Received" &&
                                          t.status === "Success",
                                      )
                                      .map((t) => t.amount)
                                      .reduce((a, b) => +a + +b, 0),
                                  )}
                                </td>
                                <td>
                                  {new Intl.NumberFormat("en-GB", {
                                    style: "currency",
                                    currency: "NGN",
                                  }).format(
                                    this.props.transactions
                                      .filter(
                                        (t) => t?.branch?.name === branchName,
                                      )
                                      .filter(
                                        (t) =>
                                          t.type === "Received" &&
                                          t.status === "Failed",
                                      )
                                      .map((t) => t.amount)
                                      .reduce((a, b) => +a + +b, 0),
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </CardContent>
                    </Card>
                  ) : null}

                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">Transactions</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">SNo.</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Wallet ID
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction ID
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Order ID</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction Amount
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Type</span>
                            </th>
                            <th>
                              <span className="table-head-label">Status</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Timestamp
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Branch</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.transactions.length > 0 ? (
                            this.props.transactions
                              .sort((a, b) => +b.timestamp - a.timestamp)
                              .map(
                                (
                                  {
                                    id,
                                    walletId,
                                    orderAmount,
                                    orderId,
                                    type,
                                    amount,
                                    timestamp,
                                    status,
                                    branch,
                                  },
                                  i,
                                ) => (
                                  <tr key={id}>
                                    <td>{i + 1}</td>
                                    <td>{walletId}</td>
                                    <td>{id}</td>
                                    <td>
                                      <div>{orderId ? orderId : "-"}</div>
                                    </td>
                                    <td
                                      style={{
                                        color:
                                          status === "Success" &&
                                          type === "Received"
                                            ? "green"
                                            : "red",
                                      }}
                                    >
                                      <div>
                                        {new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(amount)}
                                      </div>
                                    </td>
                                    <td>
                                      {" "}
                                      {type === "Received" &&
                                      status === "Failed"
                                        ? "Declined"
                                        : type}
                                    </td>
                                    <td
                                      style={{
                                        color:
                                          status === "Failed" ? "red" : "green",
                                      }}
                                    >
                                      {status}
                                    </td>
                                    <td>
                                      <div>{moment(timestamp).fromNow()}</div>
                                    </td>
                                    <td>
                                      <div>{branch?.name || "HQ"}</div>
                                    </td>
                                  </tr>
                                ),
                              )
                          ) : (
                            <tr>
                              <td colSpan="7">
                                <Block
                                  style={{
                                    backgroundColor: "#b3e5ff",
                                    borderLeft: "3px solid #03a9f4",
                                    color: "#03a9f4",
                                    marginTop: 0,
                                    paddingTop: "16px",
                                    paddingBottom: "16px",
                                    width: "100%",
                                  }}
                                >
                                  <small>
                                    No transactions available at the moment
                                  </small>
                                </Block>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                </Col>
              </Row>
            </Block>
          </Tab>

          {/* Orders Tab */}
          <Tab id="delivery-orders">
            <Block>
              <Row>
                <Col width="100" className="xsmall-100">
                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">All Orders</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">Action</span>
                            </th>
                            <th>
                              <span className="table-head-label">Order ID</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Order Status
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Delivery Fee
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                % Commission
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Net Delivery Fee
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Branch</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Timestamp
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.orders.length === 0 ? (
                            <tr>
                              <td colSpan="7">
                                <Block
                                  style={{
                                    backgroundColor: "#b3e5ff",
                                    borderLeft: "3px solid #03a9f4",
                                    color: "#03a9f4",
                                    marginTop: 0,
                                    paddingTop: "16px",
                                    paddingBottom: "16px",
                                    width: "100%",
                                  }}
                                >
                                  <small>No New / Pending Orders</small>
                                </Block>
                              </td>
                            </tr>
                          ) : (
                            this.props.orders
                              .sort(
                                (a, b) =>
                                  +moment(b.timestamp) - +moment(a.timestamp),
                              )
                              .sort((a, b) => {
                                if (a.orderStatus === "Order Cancelled") {
                                  if (b.orderStatus === "Order Completed")
                                    return -1;
                                  if (
                                    b.orderStatus === "Order Pending" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation"
                                  )
                                    return 1;
                                  return 0;
                                }

                                if (
                                  a.orderStatus === "Order Pending Delivery"
                                ) {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  if (b.orderStatus === "Order Pending")
                                    return 1;
                                  return 0;
                                }

                                if (
                                  a.orderStatus === "Order Pending Confirmation"
                                ) {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  if (
                                    b.orderStatus === "Order Pending" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation"
                                  )
                                    return 1;
                                  return 0;
                                }

                                if (a.orderStatus === "Order Pending") {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  return 0;
                                }

                                if (a.orderStatus === "Order Completed") {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Pending"
                                  )
                                    return 1;
                                  return 0;
                                }
                              })
                              .map((order) =>
                                order.orderStatus ===
                                "Order Pending Delivery" ? (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        fill
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title: "Process Order",
                                                  which: "process-order",
                                                  order,
                                                },
                                              });
                                              this.initMap(order.geoLoc);
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        Process
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {order?.agent?.branch?.name || "HQ"}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ) : order.orderStatus ===
                                  "Order Pending Confirmation" ? (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        fill
                                        className="button button-fill-blue"
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                walletId,
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                  geoLoc,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                                geoLoc,
                                                walletId,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title:
                                                    "Delivery Confirmation",
                                                  which: "confirm-order",
                                                  order,
                                                },
                                              });
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        Confirm
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {order?.agent?.branch?.name || "HQ"}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        outline
                                        style={{
                                          backgroundImage:
                                            order.orderStatus ===
                                            "Order Rejected"
                                              ? "linear-gradient(#FF6969, #E02020)"
                                              : "",
                                          color:
                                            order.orderStatus ===
                                            "Order Rejected"
                                              ? "white"
                                              : "",
                                        }}
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title: "Processed Order",
                                                  which: "processed-order",
                                                  order,
                                                },
                                              });
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        {order.orderStatus === "Order Rejected"
                                          ? "Issue"
                                          : "Processed"}
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {order?.agent?.branch?.name || "HQ"}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ),
                              )
                          )}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                </Col>

                <Col width="100" className="xsmall-100">
                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">Trips Chart</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <Block
                        style={{
                          backgroundColor: "#ffe0b2",
                          borderLeft: "3px solid #ff9800",
                          color: "#ef6c00",
                          marginTop: 0,
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          fontSize: "10px",
                        }}
                      >
                        <Row>
                          <Col>
                            <p>Trips Chart Coming Soon!</p>
                          </Col>
                        </Row>
                      </Block>
                    </CardContent>
                  </Card>
                </Col>
              </Row>
            </Block>
          </Tab>

          {/* Branches Tab */}
          {/* show tab if delivery company has access to create branches */}
          {this.props.delivery[this.props.auth.uid].branchAccess ? (
            <Tab id="delivery-branches">
              <Card className="data-table data-table-init">
                <CardHeader>
                  <div className="data-table-title">All Delivery Branches</div>
                  <div className="data-table-actions">
                    <Button
                      outline
                      iconF7="plus_circle"
                      onClick={() => {
                        this.setState({
                          popupOpened: true,
                          popupDataChanged: true,
                          popupData: {
                            title: "Branch Details",
                            which: "add-branch",
                          },
                        });
                      }}
                    >
                      &nbsp;&nbsp;&nbsp;Add Branch
                    </Button>
                  </div>
                </CardHeader>
                <CardContent padding={false}>
                  {(this.props.delivery[this.props.auth.uid]?.branchCount &&
                    !this.props.branches.delivery) ||
                  this.props.branches?.length === 0 ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : !this.props.delivery[this.props.auth.uid]?.branchCount ? (
                    <Block
                      style={{
                        backgroundColor: "#b3e5ff",
                        borderLeft: "3px solid #03a9f4",
                        color: "#03a9f4",
                        marginTop: 0,
                        paddingTop: "16px",
                        paddingBottom: "16px",
                      }}
                    >
                      <small>
                        You don't have any branch &nbsp;&nbsp;&nbsp;
                      </small>
                    </Block>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th className="label-cell">Action</th>
                          <th className="label-cell">Branch Name</th>
                          <th className="label-cell">Branch Phone</th>
                          <th className="label-cell">Branch Address</th>
                          <th className="label-cell">Branch State</th>
                          <th className="label-cell">Branch City</th>
                          <th className="label-cell">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props?.branches.delivery?.map(
                          ({
                            id,
                            name,
                            phone,
                            address,
                            state,
                            suspended,
                            city,
                            geoLoc,
                          }) => (
                            <tr key={id}>
                              <td className="label-cell">
                                <Button
                                  outline
                                  iconF7="pencil"
                                  onClick={() => {
                                    this.setState({
                                      ...this.state,
                                      branch: {
                                        ...this.state.branch,
                                        id,
                                        name,
                                        phone,
                                        city,
                                        state,
                                        address,
                                        geoLoc,
                                      },

                                      popupOpened: true,
                                      popupDataChanged: true,
                                      popupData: {
                                        title: "Branch Details",
                                        which: "edit-branch",
                                      },
                                    });
                                  }}
                                >
                                  &nbsp;&nbsp;&nbsp;Edit
                                </Button>
                              </td>
                              <td className="label-cell">
                                <div>{name}</div>
                              </td>
                              <td className="label-cell">
                                <div>{phone}</div>
                              </td>
                              <td className="label-cell">
                                <div>{address}</div>
                              </td>
                              <td className="label-cell">
                                <div>{state}</div>
                              </td>
                              <td className="label-cell">
                                <div>{city}</div>
                              </td>
                              <td className="label-cell">
                                <div>{!suspended ? "Active" : "Suspended"}</div>
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  )}
                </CardContent>
              </Card>
            </Tab>
          ) : null}
        </Tabs>

        {/* Tabbar for switching views-tabs to use lables add "label" to Toolbar and add text properties to Links*/}
        <Toolbar tabbar bottom id="delivery-tab" label>
          <Link
            tabLink="#delivery-agents"
            iconF7="car_fill"
            text="Agents"
            tabLinkActive
          />
          <Link tabLink="#delivery-wallet" iconF7="creditcard" text="Wallet" />
          <Link tabLink="#delivery-orders" iconF7="bell" text="Orders">
            {this.props.orders.filter(
              (order) => order.orderStatus === "Order Pending Delivery",
            ).length > 0 ? (
              <Badge
                color="red"
                style={{ position: "absolute", top: 0, left: "50%" }}
              >
                {
                  this.props.orders.filter(
                    (order) => order.orderStatus === "Order Pending Delivery",
                  ).length
                }
              </Badge>
            ) : null}
          </Link>

          {/* show link if delivery company has access to create branches */}
          {this.props.delivery[this.props.auth.uid].branchAccess ? (
            <Link
              tabLink="#delivery-branches"
              iconF7="arrow_branch"
              text="Branches"
            />
          ) : null}
        </Toolbar>

        {/* Popup for forms - Todo: use webworker to process these forms */}
        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          ref={this.popupRef}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", order: "" },

              addBranchButton: "Upload Branch Details",
              branch: {
                geoLoc: this.state.branch.geoLoc,
                deliveryAgentId: this.props.auth.uid,
                name: "",
                address: "",
                state: "",
                city: "",
                phone: "",
              },

              branchMD: false,

              agent: {
                ...this.state.agent,
                images: {
                  agentImage: null,
                  driverLicense: null,
                },
                name: "",
                address: "",
                phone: "",
                status: "Free",
                branch: "",
              },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for add agent details */}
            {this.state.popupData.which == "add-agent" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader className="no-border">
                    <h1
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: "40px",
                      }}
                    >
                      Agent Editor
                    </h1>
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="agent-editor">
                      <ListInput
                        label="Agent image"
                        type="file"
                        placeholder="Please select an image"
                        info="Image formats png|jpg|jpeg"
                        required
                        validate
                        onChange={(e) => {
                          const reader = new FileReader();
                          reader.onload = (ev) =>
                            this.setState({
                              ...this.state,
                              agentImage1: ev.target.result,
                            });
                          reader.readAsDataURL(e.target.files[0]);
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              images: {
                                ...this.state.agent.images,
                                agentImage: e.target.files[0],
                              },
                            },
                          });
                        }}
                      >
                        <img
                          slot="media"
                          src={this.state.agentImage1}
                          width="44"
                        />
                      </ListInput>

                      <ListInput
                        label="Agent drivers license"
                        type="file"
                        placeholder="Please select an image"
                        info="Image formats png|jpg|jpeg"
                        required
                        validate
                        onChange={(e) => {
                          const reader = new FileReader();
                          reader.onload = (ev) =>
                            this.setState({
                              ...this.state,
                              agentImage2: ev.target.result,
                            });
                          reader.readAsDataURL(e.target.files[0]);
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              images: {
                                ...this.state.agent.images,
                                driverLicense: e.target.files[0],
                              },
                            },
                          });
                        }}
                      >
                        <img
                          slot="media"
                          src={this.state.agentImage2}
                          width="44"
                        />
                      </ListInput>

                      <ListInput
                        label="Agent fullname"
                        type="text"
                        placeholder="Type agent name here"
                        info="Agent name is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.name}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              name: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="person" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Agent address"
                        type="text"
                        placeholder="Type agent address here"
                        info="Agent address is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.address}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              address: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="pencil_outline" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Agent phone"
                        type="number"
                        placeholder="eg: 090392848828"
                        info="Agent phone number is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.phone}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              phone: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="phone" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Branch name"
                        type="select"
                        name="bank"
                        style={{ paddingLeft: 0 }}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              branch: e.target.value
                                ? this.props.branches.delivery
                                    .map((branch) => ({
                                      id: branch.id,
                                      name: branch.name,
                                    }))
                                    .find(
                                      (branch) => branch.id === e.target.value,
                                    )
                                : "",
                            },
                          })
                        }
                      >
                        <Icon f7="arrow_branch" slot="media" />
                        <option key="HQ" value="">
                          HQ
                        </option>
                        {this.props.branches.delivery.map(({ id, name }) => (
                          <option key={id} value={id}>
                            {name}
                          </option>
                        ))}
                      </ListInput>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      onClick={this.addAgent.bind(this)}
                    >
                      {this.state.addAgentButton} &nbsp;{" "}
                      {this.state.addAgentButton !== "Upload Agent Details" && (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for add/edit branch details */}
            {this.state.popupData.which == "add-branch" ||
            this.state.popupData.which == "edit-branch" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader className="no-border">
                    <h1
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: "40px",
                      }}
                    >
                      Branch Editor
                    </h1>
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="branch-editor">
                      <ListInput
                        label="Branch name"
                        type="text"
                        placeholder="Type branch name here"
                        required
                        validate
                        clearButton
                        value={this.state.branch.name}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            branch: {
                              ...this.state.branch,
                              name: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="person" slot="media" />
                        {this.state.branch.name ? (
                          <span slot="info" className="text-green font-bold">
                            {`${
                              this.props.delivery[this.props.auth.uid]
                                .businessProfile.name +
                              " - " +
                              this.state.branch.name
                            } `}{" "}
                          </span>
                        ) : (
                          <span slot="info"> Branch name is required</span>
                        )}
                      </ListInput>

                      <ListInput
                        label="Branch phone"
                        type="number"
                        placeholder="eg: 090392848828"
                        info="Branch phone number is required"
                        required
                        validate
                        clearButton
                        value={this.state.branch.phone}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            branch: {
                              ...this.state.branch,
                              phone: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="phone" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Branch address"
                        type="text"
                        placeholder="Type branch address here"
                        info="Branch address is required"
                        id="branch_address"
                        required
                        validate
                        clearButton
                        value={this.state.branch.address}
                        onBlur={(e) => {
                          if (e.target.value.trim() === "") {
                            return toast(this.$f7.toast, {
                              text: `Please enter a valid address`,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }
                        }}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            branch: {
                              ...this.state.branch,
                              address: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="pencil_outline" slot="media" />
                      </ListInput>

                      <ListInput
                        label="State"
                        type="select"
                        placeholder="Please select state"
                        info="Select state from dropdown"
                        required
                        value={this.state.branch.state}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            branch: {
                              ...this.state.branch,
                              state: e.target.value,
                            },
                          })
                        }
                      >
                        <option></option>
                        {[
                          ...new Set(
                            cities
                              .filter(
                                (cityInfo) =>
                                  cityInfo.country ===
                                  this.props.delivery[this.props.auth.uid]
                                    .businessProfile.country,
                              )
                              .map((cityInfo) => cityInfo.admin_name),
                          ),
                        ]
                          .sort()
                          .map((stateName, i) => (
                            <option key={i} value={stateName}>
                              {stateName}
                            </option>
                          ))}
                        <Icon
                          f7="globe"
                          slot="media"
                          style={{
                            color: this.state.branchEdit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>

                      <ListInput
                        label="City"
                        type="select"
                        placeholder="Please select city"
                        info="Select city from dropdown"
                        required
                        value={this.state.branch.city}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            branch: {
                              ...this.state.branch,
                              city: e.target.value,
                            },
                          })
                        }
                      >
                        <option></option>
                        {this.state.branch.state &&
                          [
                            ...new Set(
                              cities
                                .filter(
                                  (cityInfo) =>
                                    cityInfo.country ===
                                      this.props.delivery[this.props.auth.uid]
                                        .businessProfile.country &&
                                    cityInfo.admin_name ===
                                      this.state.branch.state,
                                )
                                .map((cityInfo) => cityInfo.city),
                            ),
                          ]
                            .sort()
                            .map((cityName, i) => (
                              <option key={i} value={cityName}>
                                {cityName}
                              </option>
                            ))}
                        <Icon
                          f7="globe"
                          slot="media"
                          style={{
                            color: this.state.branchEdit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "20pt auto" }}>
                  <CardHeader className="no-border">
                    <BlockTitle className="m-0">
                      Branch Exact Geo-location
                    </BlockTitle>
                  </CardHeader>
                  <CardContent className="no-padding">
                    <div
                      id="branchMap"
                      className="business-map"
                      style={{
                        height: "250px",
                      }}
                    >
                      {" "}
                      <BranchMap
                        center={
                          this.state.branch.geoLoc?.lat !== "" &&
                          this.state.branch.geoLoc?.lng !== ""
                            ? this.state.branch.geoLoc
                            : { lat: 4.824167, lng: 7.033611 }
                        }
                        moveMarker={this.moveMarker.bind(this)}
                        onMapClicked={this.onMapClicked.bind(this)}
                        fetchPlaces={this.fetchPlaces.bind(this)}
                      />
                    </div>
                  </CardContent>

                  {this.state.popupData.which == "add-branch" ? (
                    <CardFooter>
                      <Button
                        round
                        fill
                        disabled={
                          this.state.addBranchButton !== "Upload Branch Details"
                        }
                        style={{ width: "100%" }}
                        onClick={this.addBranch.bind(this)}
                      >
                        {this.state.addBranchButton} &nbsp;{" "}
                        {this.state.addBranchButton !==
                          "Upload Branch Details" && <Preloader></Preloader>}
                      </Button>
                    </CardFooter>
                  ) : null}
                </Card>

                {this.state.popupData.which == "edit-branch" ? (
                  <>
                    <Card
                      style={{ margin: "20pt auto" }}
                      className="data-table data-table-init"
                    >
                      <CardHeader className="no-border">
                        <div className="data-table-title">Branch Managers</div>
                        <div className="data-table-actions">
                          <Button
                            outline
                            iconF7={
                              !this.state.branchMD
                                ? "person_crop_circle_badge_plus"
                                : "eye_slash"
                            }
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                branchMD: !this.state.branchMD,
                              });
                            }}
                          >
                            &nbsp;&nbsp;&nbsp;
                            {!this.state.branchMD ? "Add Manager" : "Hide Form"}
                          </Button>
                        </div>
                      </CardHeader>
                      <CardContent padding={false}>
                        {this.state.branchMD ? (
                          <Block
                            style={{
                              margin: "0 0 32px",
                              padding: 16,
                            }}
                          >
                            <Row>
                              <Col width={70} xsmall={75}>
                                <List
                                  noHairlinesMd
                                  style={{ margin: "auto -16px" }}
                                >
                                  <ListInput
                                    type="email"
                                    label="Email"
                                    floatingLabel
                                    validate
                                    value={this.state.MDEmail}
                                    onChange={(e) => {
                                      this.setState({
                                        ...this.state,
                                        MDEmail: e.target.value,
                                      });
                                    }}
                                    onValidate={(isValid) =>
                                      console.log(isValid)
                                    }
                                    placeholder="Enter user email here"
                                    autofocus={true}
                                  >
                                    <Icon
                                      f7="link_circle_fill"
                                      slot="media"
                                      size={38}
                                      color="red"
                                    />
                                  </ListInput>
                                </List>
                              </Col>
                              <Col width={30} xsmall={25}>
                                <Button
                                  fill
                                  iconF7="person_crop_circle_badge_checkmark"
                                  className="button-fill-green"
                                  onClick={this.addBranchManager.bind(this)}
                                >
                                  &nbsp;&nbsp;&nbsp;Add
                                </Button>
                              </Col>
                            </Row>
                          </Block>
                        ) : null}
                        {!this.props?.branches.delivery.find(
                          ({ id }) => id === this.state.branch?.id,
                        )?.managers?.length ? (
                          <Block
                            style={{
                              backgroundColor: "#b3e5ff",
                              borderLeft: "3px solid #03a9f4",
                              color: "#03a9f4",
                              padding: 16,
                            }}
                          >
                            <small>
                              Grant access to branch by adding managers
                            </small>
                          </Block>
                        ) : (
                          <table>
                            <thead>
                              <tr>
                                <th className="label-cell">Action</th>
                                <th className="label-cell">Manager Name</th>
                                <th className="label-cell">Manager Phone</th>
                                <th className="label-cell">Manager Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props?.branches.delivery
                                .find(({ id }) => id === this.state.branch?.id)
                                ?.managers?.map(
                                  ({ name, phone, email, uid }) => (
                                    <tr key={uid}>
                                      <td className="label-cell">
                                        <Button
                                          fill
                                          style={{
                                            backgroundImage:
                                              "linear-gradient(#FF6969, #E02020)",
                                            color: "white",
                                            maxWidth: "41px",
                                          }}
                                          iconF7="trash_circle"
                                          onClick={() =>
                                            this.removeManager(uid)
                                          }
                                        ></Button>
                                      </td>
                                      <td className="label-cell">
                                        <div>{name}</div>
                                      </td>
                                      <td className="label-cell">
                                        <div>{phone}</div>
                                      </td>
                                      <td className="label-cell">{email}</td>
                                    </tr>
                                  ),
                                )}
                            </tbody>
                          </table>
                        )}
                      </CardContent>
                      <CardFooter>
                        <Button
                          round
                          fill
                          style={{ width: "100%" }}
                          className="button button-fill-blue"
                          onClick={this.editBranch.bind(this)}
                        >
                          Save Branch Details
                        </Button>
                      </CardFooter>
                    </Card>

                    <Card
                      style={{ margin: "20pt auto" }}
                      inner
                      accordionList
                      className="bg-color-red"
                    >
                      <AccordionItem>
                        <AccordionToggle>
                          <CardHeader className="text-white">
                            DANGER ZONE
                            <Button
                              outline
                              iconF7="arrowtriangle_down_fill"
                              className="text-white"
                              style={{ borderColor: "#ffffff" }}
                            ></Button>
                          </CardHeader>
                        </AccordionToggle>

                        <AccordionContent>
                          <CardContent>
                            <h2 className="text-white text-center">
                              Are you sure you want to delete this branch?{" "}
                              <br />
                            </h2>
                            <h4 className="text-white text-center">
                              This action can not be revoked!
                            </h4>
                          </CardContent>
                          <CardFooter className="justify-center bg-color-pink">
                            <Button
                              fill
                              style={{
                                backgroundImage:
                                  "linear-gradient(#FF6969, #E02020)",
                                color: "white",
                              }}
                              iconF7="trash"
                              onClick={this.deleteBranch.bind(this)}
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;Delete Branch
                            </Button>
                          </CardFooter>
                        </AccordionContent>
                      </AccordionItem>
                    </Card>
                  </>
                ) : null}
              </Block>
            ) : null}

            {/* Content for add bank details */}
            {this.state.popupData.which == "add-bank" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader className="no-border">
                    <h1
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: "40px",
                      }}
                    >
                      Bank Account Editor
                    </h1>
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="bank-editor">
                      <ListInput
                        label="Account name"
                        type="text"
                        info="Account name is automated"
                        disabled={true}
                        value={this.state.bank.accountName}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountName: e.target.value,
                            },
                          })
                        }
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Account number"
                        type="number"
                        placeholder="eg: 0123456789"
                        info="Bank account number is required"
                        required
                        validate
                        clearButton
                        value={this.state.bank.accountNumber}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountNumber: e.target.value,
                            },
                          })
                        }
                      >
                        <Icon f7="creditcard_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank name"
                        type="select"
                        name="bank"
                        style={{ paddingLeft: 0 }}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              bankName: e.target.value,
                              bankCode: this.state.banks.find(
                                (bank) => bank.name === e.target.value,
                              ).code,
                            },
                          })
                        }
                      >
                        <Icon f7="car_fill" slot="media" />
                        <option></option>
                        {this.state.banks.map((bank) => (
                          <option key={bank.name} value={bank.name}>
                            {bank.name}
                          </option>
                        ))}

                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank sort code"
                        type="text"
                        placeholder="Type sort code of account here"
                        info="Bank sort code is optional"
                        clearButton
                        value={this.state.bank.sortCode}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              sortCode: e.target.value,
                            },
                          })
                        }
                      >
                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      disabled={
                        this.state.addBankButton !== "Upload Bank Details"
                      }
                      style={{ width: "100%" }}
                      onClick={this.addBank.bind(this)}
                    >
                      {this.state.addBankButton} &nbsp;{" "}
                      {this.state.addBankButton !== "Upload Bank Details" && (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for process order */}
            {this.state.popupData.which == "process-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map((product, i) => (
                        <ListItem title={product.name} key={i}>
                          <b slot="media">{product.count} x &nbsp;</b>
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>

                    <BlockTitle
                      style={{
                        marginLeft: "0px",
                      }}
                    >
                      Delivery location
                    </BlockTitle>
                    <div
                      id="deliveryLocationMap"
                      className="business-map"
                      style={{
                        height: "250px",
                      }}
                    ></div>
                  </CardContent>
                  <CardFooter>
                    <Button
                      className="button-fill-blue"
                      round
                      fill
                      style={{ width: "100%" }}
                      target="_blank"
                      href={`http://maps.apple.com/?ll=${this.state.popupData.order.geoLoc.lat},${this.state.popupData.order.geoLoc.lng}&z=10&t=s`}
                      external
                      onClick={() =>
                        this.$f7.methods.intents.openMap(
                          this.state.popupData.order.geoLoc,
                        )
                      }
                    >
                      Open Map Navigation
                    </Button>
                  </CardFooter>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      popupClose
                      href={`tel://${this.state.popupData.order.merchantDetails.phone}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.merchantDetails.phone,
                        )
                      }
                    >
                      Contact Merchant
                    </Button>
                  </CardFooter>
                </Card>

                {this.state.popupData.order.agent?.branch ? (
                  <Card style={{ margin: "auto", marginTop: "10pt" }}>
                    <CardHeader className="no-border">
                      Delivery Branch Details
                    </CardHeader>
                    <CardContent>
                      <List>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.name}
                          after="Branch Name"
                        >
                          <Icon f7="arrow_branch" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={
                            this.state.popupData.order.agent?.branch.address
                          }
                          after="Branch Address"
                        >
                          <Icon f7="placemark_fill" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.phone}
                          after="Branch Phone"
                        >
                          <Icon f7="phone_fill_arrow_up_right" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Assign Agent</CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Agents"
                        type="select"
                        name="agent"
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            deliveryPersonId: e.target.value,
                          })
                        }
                        style={{ paddingLeft: 0 }}
                      >
                        <Icon f7="car_fill" slot="media" />
                        <option></option>
                        {this.props.agents.map((agent) => (
                          <option key={agent.id} value={agent.id}>
                            {agent.id} - {agent.name}
                          </option>
                        ))}
                      </ListInput>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{
                        width: "45%",
                        backgroundImage: "linear-gradient(#FF6969, #E02020)",
                        color: "white",
                      }}
                      disabled={this.state.acceptOrderButton === ""}
                      onClick={(e) =>
                        this.declineOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.declineOrderButton === "Decline Order" ? (
                        this.state.declineOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>

                    <Button
                      round
                      fill
                      style={{ width: "45%" }}
                      disabled={this.state.declineOrderButton === ""}
                      onClick={(e) =>
                        this.acceptOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.acceptOrderButton === "Accept Order" ? (
                        this.state.acceptOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for confirm order */}
            {this.state.popupData.which == "confirm-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        ({ productId, count, name }) => (
                          <ListItem title={name} key={productId}>
                            <b slot="media">{count} x &nbsp;</b>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      popupClose
                      href={`tel://${this.state.popupData.order.merchantDetails.phone}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.merchantDetails.phone,
                        )
                      }
                    >
                      Contact Merchant
                    </Button>
                  </CardFooter>
                </Card>

                {this.state.popupData.order.agent?.branch ? (
                  <Card style={{ margin: "auto", marginTop: "10pt" }}>
                    <CardHeader className="no-border">
                      Delivery Branch Details
                    </CardHeader>
                    <CardContent>
                      <List>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.name}
                          after="Branch Name"
                        >
                          <Icon f7="arrow_branch" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={
                            this.state.popupData.order.agent?.branch.address
                          }
                          after="Branch Address"
                        >
                          <Icon f7="placemark_fill" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.phone}
                          after="Branch Phone"
                        >
                          <Icon f7="phone_fill_arrow_up_right" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Confirmation Code
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Confirmation Code"
                        type="text"
                        placeholder="please enter code here"
                        info="Confirmation code is required"
                        required
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            confirmationCode: e.target.value,
                          })
                        }
                        clearButton
                      >
                        <Icon f7="lock_shield" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      disabled={
                        this.state.popupData.order.orderStatus ===
                          "Order Completed" ||
                        this.state.popupData.order.issue ||
                        this.state.popupData.order.orderStatus ==
                          "Order Cancelled"
                      }
                      style={{
                        width: "45%",
                        backgroundImage: "linear-gradient(#FF6969, #E02020)",
                        color: "white",
                      }}
                      onClick={() => this.$f7.$("#report-issues").show()}
                    >
                      Report Issue
                    </Button>

                    <Button
                      round
                      fill
                      style={{ width: "45%" }}
                      onClick={(e) =>
                        this.completeOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.completeOrderButton === "Complete Order" ? (
                        this.state.completeOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>

                <Card
                  style={{
                    margin: "auto",
                    marginTop: "10pt",
                    display: "none",
                    animation: "glow 2s ease 0s 1",
                  }}
                  id="report-issues"
                >
                  <CardHeader className="no-border">
                    Issue Report
                    <Button onClick={() => this.$f7.$("#report-issues").hide()}>
                      Close
                    </Button>
                  </CardHeader>
                  <CardContent>
                    <TextEditor
                      placeholder="Enter text..."
                      value={this.state.orderIssue}
                      onTextEditorChange={(value) =>
                        this.setState({
                          ...this.state,
                          orderIssue: value,
                        })
                      }
                      buttons={[
                        ["bold", "italic", "underline", "strikeThrough"],
                        ["orderedList", "unorderedList"],
                      ]}
                    />
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      onClick={(e) =>
                        this.reportOrderIssue(this.state.popupData.order)
                      }
                    >
                      {this.state.reportIssueButton === "Submit Report" ? (
                        this.state.reportIssueButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for processed order */}
            {this.state.popupData.which == "processed-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        ({ productId, count, name }) => (
                          <ListItem title={name} key={productId}>
                            <b slot="media">{count} x &nbsp;</b>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                {this.state.popupData.order.agent?.branch ? (
                  <Card style={{ margin: "auto", marginTop: "10pt" }}>
                    <CardHeader className="no-border">
                      Delivery Branch Details
                    </CardHeader>
                    <CardContent>
                      <List>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.name}
                          after="Branch Name"
                        >
                          <Icon f7="arrow_branch" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={
                            this.state.popupData.order.agent?.branch.address
                          }
                          after="Branch Address"
                        >
                          <Icon f7="placemark_fill" slot="media" />
                        </ListItem>
                        <ListItem
                          className="show-text"
                          title={this.state.popupData.order.agent?.branch.phone}
                          after="Branch Phone"
                        >
                          <Icon f7="phone_fill_arrow_up_right" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}
              </Block>
            ) : null}

            {/* Content for services settings */}
            {this.state.popupData.which == "services-settings" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader className="no-border">
                    Delivery Agents Status
                    <Button popoverOpen=".info-popover">
                      <Icon f7="info_circle" />
                    </Button>
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        header="Availability"
                        title="(turn off if you offline)"
                      >
                        <Icon f7="lightbulb_fill" slot="media" />
                        <Toggle
                          color="green"
                          slot="after"
                          defaultChecked={
                            this.props.delivery[this.props.auth.uid]
                              .currentStatus &&
                            this.props.delivery[this.props.auth.uid]
                              .currentStatus === "online"
                          }
                          onToggleChange={(e) => this.updataCurrentStatus(e)}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "20pt auto" }}>
                  <CardHeader className="no-border">Operating Times</CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Business Opening Time"
                        type="select"
                        placeholder="Please select opening time"
                        info="Select time from dropdown"
                        value={
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.operationStartTime &&
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.operationStartTime
                        }
                        onChange={(e) =>
                          this.updateOperationTime(e.target.value, "open")
                        }
                      >
                        {this.state.operatingTime.map((time, i) => (
                          <option key={i} value={time}>
                            {time}
                          </option>
                        ))}
                        <Icon f7="timer" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Business Closing Time"
                        type="select"
                        placeholder="Please select closing time"
                        info="Select time from dropdown"
                        value={
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.operationCloseTime &&
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.operationCloseTime
                        }
                        onChange={(e) =>
                          this.updateOperationTime(e.target.value, "close")
                        }
                      >
                        {this.state.operatingTime.map((time, i) => (
                          <option key={i} value={time}>
                            {time}
                          </option>
                        ))}
                        <Icon f7="timer" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "20pt auto" }}>
                  <CardHeader className="no-border">Operating Days</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.operatingDays.map((day, i) => (
                        <ListItem
                          checkbox
                          name="days-checkbox"
                          key={i}
                          value={day}
                          title={day}
                          checked={
                            this.props.delivery[this.props.auth.uid]
                              .businessProfile.operationDays &&
                            this.props.delivery[
                              this.props.auth.uid
                            ].businessProfile.operationDays.includes(day)
                          }
                          onChange={(e) => this.updateOperationDays(e, day)}
                        ></ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>

        {/* Popover */}
        <Popover className="info-popover">
          <Block style={{ textAlign: "center" }}>
            <p>
              Note: Your services would be offline, merchant will not be able to
              see your services if you turn this off!
            </p>
          </Block>
        </Popover>
      </Page>
    );
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      branchUnsub: this.props.firestore
        .collection("delivery")
        .doc(this.props.auth.uid)
        .collection("branches")
        .onSnapshot(
          (snapshot) => {
            if (!snapshot.empty) {
              const branches = [];
              snapshot.docs.forEach((doc) => {
                branches.push({
                  id: doc.id,
                  ...doc.data(),
                });
              });

              this.props.dispatch({
                type: LOAD_BRANCHES,
                payload: {
                  id: this.props.auth.uid,
                  data: branches,
                },
              });
            } else {
              this.props.dispatch({
                type: LOAD_BRANCHES,
                payload: {
                  id: this.props.auth.uid,
                  data: [],
                },
              });
            }
          },
          (error) => {
            toast(this.$f7.toast, {
              text: "Unable to fetch branches, please reload page.",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          },
        ),
    });
  }

  componentDidUpdate(prevProps) {
    // Auto update wallet name
    if (
      (!prevProps.wallets ||
        (prevProps.delivery[prevProps.auth.uid] &&
          !prevProps.wallets[
            prevProps.delivery[prevProps.auth.uid].walletId
          ])) &&
      this.props.wallets &&
      this.props.delivery[this.props.auth.uid] &&
      this.props.wallets[this.props.delivery[this.props.auth.uid].walletId] &&
      !this.props.wallets[this.props.delivery[this.props.auth.uid].walletId]
        .name
    ) {
      this.props.firestore
        .collection("wallets")
        .doc(this.props.delivery[this.props.auth.uid].walletId)
        .update({
          name: this.props.delivery[this.props.auth.uid].businessProfile.name,
        })
        .catch((error) => {});
    }
  }

  // componentWillUnmount() {
  //   if (this.state.branchUnsub) {
  //     this.state.branchUnsub();
  //   }
  // }

  //Events
  updataCurrentStatus(status) {
    this.$f7.preloader.show();
    let currentStatus = status ? "online" : "offline";
    this.props.firestore
      .collection("delivery")
      .doc(this.props.auth.uid)
      .update({ currentStatus })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  updateOperationTime(time, when) {
    this.$f7.preloader.show();
    const startOrCloseTime =
      when === "open" ? "operationStartTime" : "operationCloseTime";
    const update = {
      ...this.props.delivery[this.props.auth.uid].businessProfile,
      [startOrCloseTime]: time,
    };

    this.props.firestore
      .collection("delivery")
      .doc(this.props.auth.uid)
      .update({ businessProfile: update })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  updateOperationDays(e, day) {
    this.$f7.preloader.show();
    const update = {
      ...this.props.delivery[this.props.auth.uid].businessProfile,
    };

    if (e.target.checked) {
      update.operationDays = this.props.delivery[this.props.auth.uid]
        .businessProfile.operationDays
        ? [
            ...this.props.delivery[this.props.auth.uid].businessProfile
              .operationDays,
            day,
          ]
        : [day];
    } else {
      update.operationDays = update.operationDays.filter((d) => d !== day);
    }

    this.props.firestore
      .collection("delivery")
      .doc(this.props.auth.uid)
      .update({ businessProfile: update })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  withdrawalRetry(pw) {
    this.$f7.preloader.show();
    // make transfer
    const transferDetails = {
      amount: pw.amount,
      recipient: pw.recipient,
      reason: {
        walletId: pw.reason.walletId,
        email: pw.reason.email,
        commission: pw.reason.commission,
      },
      retry: {
        reference: pw.reference,
      },
    };

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        transferDetails.token = idToken;
        transferDetails.uid = this.props.auth.uid;

        // initiate transfer
        initiateATransfer(transferDetails, (error, data) => {
          if (error) {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: error,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          }

          this.$f7.preloader.hide();
          return this.$f7.dialog.alert(
            "Processing transaction, you will recieve a mail shortly",
          );
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  initiateTransfer() {
    this.$f7.preloader.show();
    this.setState({
      ...this.state,
      withdrawalButton: "",
    });

    const walletBalance =
      this.props.wallets[this.props.delivery[this.props.auth.uid].walletId]
        .walletBalance;

    const pendingWithdrawal = this.props.wallets[
      this.props.delivery[this.props.auth.uid].walletId
    ].pendingWithdrawal
      ? this.props.wallets[
          this.props.delivery[this.props.auth.uid].walletId
        ].pendingWithdrawal
          .map((pw) => pw.amount / 100 + pw.reason.commission)
          .reduce((a, b) => a + b, 0)
      : 0;

    if (this.state.withdrawalInfo.recipientCode === "") {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Select a bank account",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (this.state.withdrawalInfo.amount < 1000) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Mininmum withdrawal is NGN1,000",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (
      +this.state.withdrawalInfo.amount +
        +payStackTransferCharge(this.state.withdrawalInfo.amount) >
      +walletBalance - pendingWithdrawal
    ) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Insufficient Balance",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    const bankAccount = this.props.wallets[
      this.props.delivery[this.props.auth.uid].walletId
    ].bankDetails.find(
      ({ recipientCode }) =>
        recipientCode === this.state.withdrawalInfo.recipientCode,
    );

    this.$f7.preloader.hide();

    this.$f7.dialog.confirm(
      `
    <p><strong>Bank:</strong> ${bankAccount.bankName}</p>
    <p><strong>Account Name:</strong> ${bankAccount.accountName}</p>
    <p><strong>Account Number:</strong> ${bankAccount.accountNumber}</p>
    <p><strong>Amount:</strong> ${new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "NGN",
    }).format(+this.state.withdrawalInfo.amount)}</p>
    <p>You will be charged <strong>${new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "NGN",
    }).format(
      +payStackTransferCharge(this.state.withdrawalInfo.amount),
    )}</strong> for this transaction.</p>
    `,
      "Confirm Transaction",
      () => {
        // make transfer
        const transferDetails = {
          amount: `${+this.state.withdrawalInfo.amount * 100}`,
          recipient: this.state.withdrawalInfo.recipientCode,
          reason: {
            walletId: this.props.delivery[this.props.auth.uid].walletId,
            email:
              this.props.delivery[this.props.auth.uid].businessProfile.email,
            commission: +payStackTransferCharge(
              this.state.withdrawalInfo.amount,
            ),
          },
        };

        this.$f7.preloader.show();

        this.props.firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            transferDetails.token = idToken;
            transferDetails.uid = this.props.auth.uid;

            // send OTP to merchant's email
            sendOneTimePassword(
              { type: "delivery", token: idToken, uid: this.props.auth.uid },
              (error, sent) => {
                if (error || !sent) {
                  this.setState({
                    ...this.state,
                    withdrawalButton: "Confirm Transaction",
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: error,
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }

                // open a dialog to confirm OTP
                this.$f7.preloader.hide();
                this.$f7.dialog
                  .create({
                    title: "OTP CODE",
                    cssClass: "otp-code-modal",
                    text: "Confirm withdrawal by filling in the OTP code sent to your email address",
                    content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                    buttons: [
                      // button to resend otp
                      {
                        text: "Resend Code",
                        color: "gray",
                        cssClass: "otp-resend",

                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          sendOneTimePassword(
                            {
                              type: "delivery",
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, sent) => {
                              if (error || !sent) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: "Confirm Transaction",
                                });
                                // if this error is a ban, close dialog
                                if (
                                  error ===
                                  "You cannot make a withdrawal at the moment. Please contact admin."
                                ) {
                                  dialog.close();
                                }
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: "OTP code sent",
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            },
                          );
                        },
                      },
                      // button to cancel
                      {
                        text: "x",
                        color: "white",
                        cssClass: "otp-close",
                        onClick: (dialog, e) => {
                          this.setState({
                            ...this.state,
                            withdrawalButton: "Confirm Transaction",
                          });
                          this.$f7.preloader.hide();
                        },
                      },
                      // button to continue
                      {
                        text: "Continue",
                        bold: true,
                        cssClass: "otp-continue",
                        keyCodes: [13],
                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          // password
                          const password = dialog.$el
                            .find(".dialog-input")
                            .val();

                          // Verify otp
                          verifyOneTimePassword(
                            {
                              password,
                              type: "delivery",
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, success) => {
                              if (error || !success) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: "Confirm Transaction",
                                });

                                // close if ban
                                if (
                                  error ===
                                  "You cannot make a withdrawal at the moment. Please contact admin."
                                ) {
                                  dialog.close();
                                }

                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              // close dialog
                              dialog.close();

                              // initiate transfer
                              initiateATransfer(
                                transferDetails,
                                (error, data) => {
                                  if (error) {
                                    this.setState({
                                      ...this.state,
                                      withdrawalButton: "Confirm Transaction",
                                    });
                                    this.$f7.preloader.hide();
                                    return toast(this.$f7.toast, {
                                      text: error,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  }

                                  this.setState({
                                    ...this.state,
                                    withdrawalButton: "Confirm Transaction",
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      amount: 0,
                                    },
                                  });
                                  this.$f7.preloader.hide();
                                  return toast(this.$f7.toast, {
                                    text: "Processing transaction, you will recieve a mail shortly",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                },
                              );
                            },
                          );
                        },
                      },
                    ],
                  })
                  .open();
              },
            );
          })
          .catch((error) => {
            this.setState({
              ...this.state,
              withdrawalButton: "Confirm Transaction",
            });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          });
      },
      () => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          withdrawalButton: "Confirm Transaction",
        });
      },
    );
  }

  reportOrderIssue(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, reportIssueButton: "" });
    if (this.state.orderIssue.trim() === "") {
      this.setState({ ...this.state, reportIssueButton: "Submit Report" });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Please type in your issue",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({
        issue: this.state.orderIssue,
        issueTimestamp: Date.now(),
      })
      .then(() => {
        this.$f7.$("#report-issues").hide();
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          reportIssueButton: "Submit Report",
          orderIssue: "",
        });
      })
      .catch((error) => {
        this.setState({ ...this.state, reportIssueButton: "Submit Report" });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  completeOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, completeOrderButton: "" });
    if (this.state.confirmationCode.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Please enter the confirmation code provided by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (order.confirmationCode) {
      if (order.confirmationCode === this.state.confirmationCode) {
        this.props.firestore
          .collection("orders")
          .doc(order.id)
          .update({
            orderStatus: "Order Completed",
            completed: true,
            confirmationTime: Date.now(),
            triggeredBy: this.props.auth.uid,
          })
          .then(() => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", order: "" },
              completeOrderButton: "Complete Order",
              confirmationCode: "",
            });
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              completeOrderButton: "Complete Order",
            });
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          });
      } else {
        this.$f7.preloader.hide();
        this.setState({ ...this.state, completeOrderButton: "Complete Order" });
        return toast(this.$f7.toast, {
          text: "Delivery not confirmed",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }
    } else {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Confirmation code has not been generated by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  declineOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, declineOrderButton: "" });
    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({
        orderStatus: "Order Pending",
        assignedAgentId: "",
        agent: {},
        triggeredBy: this.props.auth.uid,
        assignedByAdminOrSupport: null,
        deliveryDeclinedByAdminOrSupport: null,
      })
      .then(() => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          declineOrderButton: "Decline Order",
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        this.setState({ ...this.state, declineOrderButton: "Decline Order" });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  acceptOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, acceptOrderButton: "" });
    if (this.state.deliveryPersonId.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        acceptOrderButton: "Accept Order",
      });

      return toast(this.$f7.toast, {
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
        text: "Plese select a delivery person",
      });
    }

    const agent = {
      ...order.agent,
      assignedDeliveryPerson: {
        id: this.state.deliveryPersonId,
        name: this.props.agents.find(
          ({ id }) => id === this.state.deliveryPersonId,
        ).name,
      },
    };

    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({ orderStatus: "Order Pending Confirmation", agent })
      .then(() => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          acceptOrderButton: "Accept Order",
          deliveryPersonId: "",
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          acceptOrderButton: "Accept Order",
        });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  initMap(geoLoc) {
    const map = new window.google.maps.Map(
      document.querySelector("#deliveryLocationMap"),
      {
        center: geoLoc,
        zoom: 18,
      },
    );

    // Set marker on map
    const marker = new window.google.maps.Marker({
      position: geoLoc,
      map,
      animation: window.google.maps.Animation.DROP,
    });
  }

  addAgent() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addAgentButton: "" });
    const agent = {
      ...this.state.agent,
    };

    // validate fields

    // image
    if (agent.images.agentImage === null) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select agent image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (agent.images.driverLicense === null) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select agent driver license.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // image type validation
    if (
      !["image/jpg", "image/jpeg", "image/png"].includes(
        agent.images.agentImage.type,
      )
    ) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select a valid agent image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (
      !["image/jpg", "image/jpeg", "image/png"].includes(
        agent.images.driverLicense.type,
      )
    ) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select a valid agent driver license image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // Validate image size
    if (agent.images.agentImage.size > 10000000) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Maximum image size: 10MB. (Agent image)",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (agent.images.driverLicense.size > 10000000) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Maximum image size: 10MB. (Agent license image)",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.name)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent name is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.address)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent address is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.phone)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent phone number is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    uploadFile(
      this.props.storage,
      "agents",
      this.props.auth.uid,
      agent.images.agentImage,
      (error, imageObject) => {
        if (error) {
          this.$f7.preloader.hide();
          this.setState({
            ...this.state,
            addAgentButton: "Upload Agent Details",
          });
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        }

        agent.images.agentImage = imageObject;
        uploadFile(
          this.props.storage,
          "license",
          this.props.auth.uid,
          agent.images.driverLicense,
          (error, imageObject) => {
            if (error) {
              this.$f7.preloader.hide();
              this.setState({
                ...this.state,
                addAgentButton: "Upload Agent Details",
              });
              return toast(this.$f7.toast, {
                text: handleErrors(error),
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            agent.images.driverLicense = imageObject;

            this.props.firestore
              .collection("agents")
              .doc(generateId(7))
              .set(agent)
              .then((doc) => {
                this.$f7.preloader.hide();
                this.setState({
                  ...this.state,
                  popupOpened: false,
                  addAgentButton: "Upload Agent Details",
                  agentImage1: "static/icon-512x512@1x.png",
                  agentImage2: "static/icon-512x512@1x.png",
                  agent: {
                    ...this.state.agent,
                    name: "",
                    address: "",
                    images: {
                      agentmage: null,
                      driverLicense: null,
                    },
                    phone: "",
                  },
                });
                return toast(this.$f7.toast, {
                  text: "Agent Uploaded",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              })
              .catch((error) => {
                this.$f7.preloader.hide();
                this.setState({
                  ...this.state,
                  addAgentButton: "Upload Agent Details",
                });
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });
          },
        );
      },
    );
  }

  deleteAgent(imageObject, licenseObject, id) {
    this.$f7.preloader.show();
    deleteFile(this.props.storage, imageObject.path, (error) => {
      if (error) {
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      } else {
        deleteFile(this.props.storage, licenseObject.path, (error) => {
          if (error) {
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          } else {
            this.props.firestore
              .collection("agents")
              .doc(id)
              .delete()
              .then(() => {
                toast(this.$f7.toast, {
                  text: "Agent deleted",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              })
              .catch((error) => {
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });
          }
        });
      }
      this.$f7.preloader.hide();
    });
  }

  addBank() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addBankButton: "" });
    const bankDetails = {
      ...this.state.bank,
    };

    if (isEmpty(bankDetails.accountNumber)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "Account Number is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(bankDetails.bankName)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "Bank Name is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (this.state.BanksWithIssues.includes(bankDetails.bankName)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "We have issue with this bank's API, please choose another bank.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        resolveAccountNumber(
          bankDetails.accountNumber,
          bankDetails.bankCode,
          idToken,
          this.props.auth.uid,
          (error, data) => {
            this.$f7.preloader.hide();
            if (error) {
              this.setState({
                ...this.state,
                addBankButton: "Upload Bank Details",
              });
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            this.$f7.dialog.confirm(
              `Please confirm your account name: ${data.account_name}`,
              "Account Name",
              () => {
                this.setState({
                  ...this.state,
                  bank: {
                    ...this.state.bank,
                    accountName: data.account_name,
                  },
                });
                this.$f7.preloader.show();
                bankDetails.accountName = data.account_name;

                createTransferRecipient(
                  {
                    ...bankDetails,
                    token: idToken,
                    uid: this.props.auth.uid,
                    wallet: "delivery",
                  },
                  (error, recipientCode) => {
                    if (error) {
                      this.setState({
                        ...this.state,
                        addBankButton: "Upload Bank Details",
                      });
                      this.$f7.preloader.hide();
                      return toast(this.$f7.toast, {
                        text: "Something went wrong. Try again.",
                        position: "bottom",
                        horizontalPosition: "center",
                        closeButton: true,
                        cssClass: "custom-toast",
                        closeTimeout: 4000,
                      });
                    }

                    bankDetails.recipientCode = recipientCode;

                    if (this.props.wallets) {
                      // update
                      const walletId = Object.keys(this.props.wallets)[0];
                      const update = [
                        ...this.props.wallets[
                          this.props.delivery[this.props.auth.uid].walletId
                        ].bankDetails,
                        {
                          ...bankDetails,
                        },
                      ];

                      addOrRemoveBank(
                        walletId,
                        update,
                        idToken,
                        this.props.auth.uid,
                        (error, bankAdded) => {
                          if (error) {
                            this.setState({
                              ...this.state,
                              addBankButton: "Upload Bank Details",
                            });
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.setState({
                            ...this.state,
                            popupOpened: false,
                            addBankButton: "Upload Bank Details",
                            bank: {
                              ...this.state.bank,
                              bankName: "",
                              accountName: "",
                              accountNumber: "",
                              sortCode: "",
                              bankCode: "",
                            },
                          });
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "Bank Profile Uploaded",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    } else {
                      // new
                      const walletId = generateId(7);
                      const wallet = {
                        walletBalance: 0,
                        transactions: [],
                        bankDetails: [bankDetails],
                      };
                      this.props.firestore
                        .collection("delivery")
                        .doc(this.props.auth.uid)
                        .update({ walletId })
                        .then(() => {
                          addOrRemoveBank(
                            walletId,
                            wallet,
                            idToken,
                            this.props.auth.uid,
                            (error, bankAdded) => {
                              if (error) {
                                this.setState({
                                  ...this.state,
                                  addBankButton: "Upload Bank Details",
                                });
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              this.setState({
                                ...this.state,
                                popupOpened: false,
                                addBankButton: "Upload Bank Details",
                                bank: {
                                  ...this.state.bank,
                                  bankName: "",
                                  accountName: "",
                                  accountNumber: "",
                                  sortCode: "",
                                  bankCode: "",
                                },
                              });
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: "Bank Profile Uploaded",
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            },
                          );
                        })
                        .catch((error) => {
                          this.setState({
                            ...this.state,
                            addBankButton: "Upload Bank Details",
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        });
                    }
                  },
                );
              },
              () => {
                this.setState({
                  ...this.state,
                  addBankButton: "Upload Bank Details",
                });
              },
            );
          },
        );
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          addBankButton: "Upload Bank Details",
        });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  deleteBank(index, recipientCode) {
    this.$f7.preloader.show();
    const walletId = this.props.delivery[this.props.auth.uid].walletId;
    const bankDetails = [...this.props.wallets[walletId].bankDetails];

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        deleteTransferRecipient(
          {
            recipientCode,
            token: idToken,
            uid: this.props.auth.uid,
            wallet: "delivery",
          },
          (error, isDeleted) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: "Something went wrong. Cannot delete account, please try again",
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            bankDetails.splice(index, 1);

            addOrRemoveBank(
              walletId,
              bankDetails,
              idToken,
              this.props.auth.uid,
              (error, bankRemoved) => {
                if (error) {
                  this.$f7.preloader.hide();
                  toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }

                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: "Bank Profile Deleted",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              },
            );
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();

        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : "admin";
    const previousView = args[0] ? args[0] : "account";
    const previousPage = args[2] ? args[2] : "account";

    self.$f7.views["message-master"].router.navigate(
      {
        name: "message-master",
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      },
    );
  }

  async removeManager(managerId) {
    this.$f7.preloader.show();
    try {
      const branchId = this.state.branch.id;

      const token = await this.props.firebase
        .auth()
        .currentUser.getIdToken(true);

      const { message } = await makeRequest(
        { branchId, token, managerId, uid: this.props.auth.uid },
        "unAssignDeliveryBranchManager",
      );

      this.$f7.preloader.hide();

      return toast(this.$f7.toast, {
        text: message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async addBranchManager() {
    this.$f7.preloader.show();
    try {
      const managerEmail = this.state.MDEmail;
      const branchId = this.state.branch.id;

      if (!isValidEmail(managerEmail)) {
        throw new Error(`Invalid Email Address.`);
      }

      const token = await this.props.firebase
        .auth()
        .currentUser.getIdToken(true);

      const { message } = await makeRequest(
        { branchId, token, managerEmail, uid: this.props.auth.uid },
        "assignDeliveryBranchManager",
      );

      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        MDEmail: "",
      });

      return toast(this.$f7.toast, {
        text: message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async addBranch() {
    this.setState({
      ...this.state,
      addBranchButton: "Uploading...",
    });
    try {
      const branch = {
        ...this.state.branch,
        headquatersName:
          this.props.delivery[this.props.auth.uid].businessProfile.name,
        geohash: geofire.geohashForLocation([
          this.state.branch.geoLoc.lat,
          this.state.branch.geoLoc.lng,
        ]),
      };

      for (let key in branch) {
        if (!branch[key]) throw new Error(`Please provide a valid ${key}.`);
        if (key === "phone" && branch[key].length !== 11)
          throw new Error("Invalid Phone number");
      }

      const branchExists = await this.props.firestore
        .collection("delivery")
        .doc(branch.deliveryAgentId)
        .collection("branches")
        .where("name", "==", branch.name)
        .get();

      if (!branchExists.empty)
        throw new Error(`${branch.name} branch already exist.`);

      await this.props.firestore
        .collection("delivery")
        .doc(branch.deliveryAgentId)
        .collection("branches")
        .add(branch);

      this.setState({
        ...this.state,
        addBranchButton: "Upload Branch Details",
      });
      this.popupRef.current.close();
      return toast(this.$f7.toast, {
        text: `${branch.name} has been successfully created.`,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } catch (error) {
      this.setState({
        ...this.state,
        addBranchButton: "Upload Branch Details",
      });

      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async editBranch() {
    this.$f7.preloader.show();
    try {
      const branch = {
        ...this.state.branch,
        geohash: geofire.geohashForLocation([
          this.state.branch.geoLoc.lat,
          this.state.branch.geoLoc.lng,
        ]),
      };

      for (let key in branch) {
        if (!branch[key]) throw new Error(`Please provide a valid ${key}.`);
        if (key === "phone" && branch[key].length !== 11)
          throw new Error("Invalid Phone number");
      }

      const branchId = branch.id;

      delete branch.id;

      await this.props.firestore
        .collection("delivery")
        .doc(branch.deliveryAgentId)
        .collection("branches")
        .doc(branchId)
        .update(branch);

      this.$f7.preloader.hide();
      this.popupRef.current.close();
      return toast(this.$f7.toast, {
        text: `${branch.name} has been successfully updated.`,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async deleteBranch() {
    try {
      this.$f7.preloader.show();
      await this.props.firestore
        .collection("delivery")
        .doc(this.props.auth.uid)
        .collection("branches")
        .doc(this.state.branch.id)
        .delete();

      this.$f7.preloader.hide();
      this.popupRef.current.close();
      toast(this.$f7.toast, {
        text: "Branch deleted",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  // Branch Map
  fetchPlaces(mapProps, map) {
    const self = this;
    const { google } = mapProps;
    self.setState({
      ...self.state,
      maps: google.maps,
    });

    const input = document.querySelector("#branch_address input");
    self.autocomplete = new google.maps.places.Autocomplete(input);
    self.autocomplete.setFields(["formatted_address", "geometry", "name"]);
    self.autocomplete.bindTo("bounds", map);
    self.autocomplete.addListener("place_changed", () => {
      let response = self.autocomplete.getPlace();
      if (!response.geometry) {
        this.setState({
          ...this.state,
          branch: {
            ...this.state.branch,
            address: "",
          },
        });

        return toast(self.$f7.toast, {
          text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }

      if (response) {
        this.setState({
          ...this.state,
          branch: {
            ...this.state.branch,
            address: response.name,
            geoLoc: {
              lat: response.geometry.location.lat(),
              lng: response.geometry.location.lng(),
            },
          },
        });
      }
    });
  }

  moveMarker(props, marker, e) {
    this.setState({
      ...this.state,
      branch: {
        ...this.state.branch,

        geoLoc: {
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        },
      },
    });

    useGeoCode(
      {
        type: "Address",
        data: {
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        },
      },
      (error, result) => {
        if (error) {
          return this.setState({
            ...this.state,
            branch: {
              ...this.state.branch,

              address: "",
            },
          });
        }

        this.setState({
          ...this.state,
          branch: {
            ...this.state.branch,

            address: result,
          },
        });
      },
    );
  }

  onMapClicked(mapProps, map, clickEvent) {
    this.setState({
      ...this.state,
      branch: {
        ...this.state.branch,

        geoLoc: {
          lat: clickEvent.latLng.lat(),
          lng: clickEvent.latLng.lng(),
        },
      },
    });

    useGeoCode(
      {
        type: "Address",
        data: {
          lat: clickEvent.latLng.lat(),
          lng: clickEvent.latLng.lng(),
        },
      },
      (error, result) => {
        if (error) {
          return this.setState({
            ...this.state,
            branch: {
              ...this.state.branch,
              address: "",
            },
          });
        }
        this.setState({
          ...this.state,
          branch: {
            ...this.state.branch,
            address: result,
          },
        });
      },
    );
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { agents, loading, transactions, orders, branches },
  },
}) => ({
  auth,
  loadingDoc: loading,
  agents: (agents && agents) || [],
  transactions: (transactions && transactions) || [],
  orders: (orders && orders) || [],
  branches: (branches && branches) || [],
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new DocArray("agents", props.auth.uid, "deliveryAgentId"),
    new Doc(
      "wallets",
      (props.delivery &&
        props.delivery !== null &&
        props.delivery[props.auth.uid] &&
        props.delivery[props.auth.uid].walletId &&
        props.delivery[props.auth.uid].walletId) ||
        null,
    ),
    new DocArray(
      "transactions",
      (props.delivery &&
        props.delivery[props.auth.uid] &&
        props.delivery[props.auth.uid].walletId &&
        props.delivery[props.auth.uid].walletId) ||
        null,
      "walletId",
    ),
    new DocArray(
      "orders",
      props.delivery && props.delivery[props.auth.uid] ? props.auth.uid : null,
      "assignedAgentId",
    ),
  ]),
  connect(mapStateToProps),
);

export default enhance(DeliveryAgents);
